<template>
  <graph-detail08-template
    :board-ids="[239]"
    field-code="workplace-material"
    :com-group-list="comGroupList"
    graph1-title="전체 (원료·제조물 사업장) 비상대피 훈련 현황"
    graph2-title="월별 (원료·제조물 사업장) 비상대피 훈련 현황"
    graph3-title="기간별 (원료·제조물 사업장) 비상대피 훈련 현황"
    field-label="원료·제조물 사업장"
    field-category-label="구분"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail08Template from "@/views/graph-detail/GraphDetail08Template.vue";

export default {
  name: "GraphDetail58",
  components: {
    GraphDetail08Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
